import {gql} from "@irati/utils/gql"
import partialUser from "@irati/identity/services/fragments/PartialUser"

import RewardCatalogueProduct from "./RewardCatalogueProduct"

const fragment = gql`
  fragment RewardOrder on RewardOrder {
    uuid
    createdAt
    createdBy {
      ...partialUser
    }
    updatedAt
    updatedBy {
      ...partialUser
    }
    archived
    status
    message
    custom
    product {
      ...RewardCatalogueProduct
    }
    recipients {
      results {
        ...partialUser
        teams {
          results {
            ...teamFields
          }
        }
      }
    }
    rewardId
    reward {
      uuid
      header
      thumbnailImage
      redemptionInstructions
      termsAndConditions
      isCredit
      products {
        results {
          ...RewardCatalogueProduct
        }
      }
    }
    teams {
      results {
        ...teamFields
      }
    }
    everyone
    quantity
    costPerUnit {
      amount
      currency
    }
    costTotal {
      amount
      currency
    }

    poll {
      uuid
      createdAt
      endsAt
      title
      desc
      active
      archived
      private
      createdBy {
        ...partialUser
      }
      companyValues {
        results {
          archived
          name
          tag
          uuid
        }
      }
      winners {
        results {
          user {
            ...partialUser
          }
        }
      }
      comments {
        results {
          uuid
          createdAt
          updatedAt
          createdBy {
            ...partialUser
          }
          message
          moderated
          archived
        }
      }
      votes {
        results {
          uuid
          message
          createdAt
          updatedAt
          createdBy {
            ...partialUser
          }
          user {
            ...partialUser
          }
          moderated
          archived
        }
      }
      trophy {
        alt
        href
      }
      reward {
        desc
        alt
        href
        id
        legacy
      }
      teams {
        results {
          uuid
          public_name
        }
      }
    }

    recognition {
      uuid
      createdAt
      message
      moderated
      createdBy {
        ...partialUser
      }
      companyValues {
        results {
          archived
          name
          tag
          uuid
        }
      }
      receivers {
        results {
          ...partialUser
        }
      }
    }
  }

  fragment teamFields on Team {
    uuid
    public_name
  }

  ${partialUser}
  ${RewardCatalogueProduct}
`

export default fragment
